import { post, get } from '../axios.js'

// 获取菜单
export function queryMenus(params, option) {
  return post(`${process.env.VUE_APP_BMW}/MU1001001`, params, option).then(
    response => response.data
  )
}
// 钉钉登录重定向
export function qrCodeRedirect(params) {
  return get(`${process.env.VUE_APP_BMW}/sys/qrCodeRedirect`, params)
}
export function qrCodeLogin(params) {
  return get(`${process.env.VUE_APP_BMW}/sys/qrCodeLogin`, params)
}
export function example(map) {
  return post(`${process.env.VUE_APP_BMW}/example`, map)
}
export function usersList(map) {
  // 人员列表
  return post(`${process.env.VUE_APP_BMW}/users`, map)
}
export function systemList(map) {
  // 系统列表
  return post(`${process.env.VUE_APP_BMW}/allSystem`, map)
}
export function bindRoles(map) {
  // 绑定角色
  return post(`${process.env.VUE_APP_BMW}/user/bindRoles`, map)
}
export function roles(map) {
  // 人员角色
  return post(`${process.env.VUE_APP_BMW}/user/roles`, map)
}

export function getSystems(map) {
  return post(`${process.env.VUE_APP_BMW}/allSystem`, map)
}

export function addRole(map) {
  return post(`${process.env.VUE_APP_BMW}/insertRole`, map)
}

export function invalidRole(map) {
  return post(`${process.env.VUE_APP_BMW}/invalidRoleByRoleId`, map)
}

export function changeRole(map) {
  return post(`${process.env.VUE_APP_BMW}/modifyRoleByRoleId`, map)
}

export function getRoleList(map) {
  return post(`${process.env.VUE_APP_BMW}/queryRolesBySystemId`, map)
}

export function changeRolePermission(map) {
  return post(`${process.env.VUE_APP_BMW}/newRolePermission`, map)
}

export function getPagePermissionByRole(map) {
  return post(`${process.env.VUE_APP_BMW}/queryPermissionByRoleId`, map)
}

export function changePermissionByRole(map) {
  return post(`${process.env.VUE_APP_BMW}/validityRolePermission`, map)
}

export function getRoleEmployee(map) {
  return post(
    `${process.env.VUE_APP_BMW}/queryUserRoleFromRole/${map.roleId}`,
    map
  )
}

export function changeRoleEmployee(map) {
  return post(`${process.env.VUE_APP_BMW}/insertUserRoleFromRole`, map)
}
